<template lang="pug">
  preview(backgroundColor="neutral100")
    preview-item.mt-0(title="Customer app preview")
      v-card.round-xl.neutral300.pa-2.text-left.mt-3(elevation="2" width="320px")
        .text-xs.font-semibold.neutral700--text.mt-1.mb-2 Current offers
        v-card.round-xl.pa-2(outlined)
          div.d-flex.align-center.justify-space-between
            .d-flex.align-center
              v-icon(size="24" color="#EB7100") $yzi-offers
              div.mx-3
                div.text-xs.font-medium.neutral700--text { Offer's.name }
                div.text-xxs.neutral500--text { Offer's.reward }
            v-icon(color="neutral700" size="10") mdi-chevron-right
          v-divider.my-1
          div.text-xxs.neutral500--text.px-2.py-1 Offer ends 14 Nov 2025
</template>

<script>
import Preview from '@/components/review/preview/Preview.vue'
import PreviewItem from '@/components/review/preview/PreviewItem.vue'

export default {
  components: {
    Preview, PreviewItem
  },
};
</script>

<style scoped>
</style>
